import React from "react";
import "./WhyJibuBot.css";
import { FaRobot, FaClock, FaChartLine, FaMoneyBillWave } from "react-icons/fa";

const WhyJibuBot = ({ isDarkMode }) => {
  return (
    <section className={`why-jibu-section ${isDarkMode ? "dark-mode" : "light-mode"}`}>
      <h2>Why JibuBot?</h2>
      <p className="subtext">
        Here’s why businesses trust JibuBot to automate, engage, and grow.
      </p>

      <div className="benefits-grid">
        <article className="benefit-card">
          <FaRobot className="icon" />
          <h3>Smart Automation</h3>
          <p>Powered by AI to handle real-time queries and automate conversations with human-like intelligence.</p>
        </article>

        <article className="benefit-card">
          <FaClock className="icon" />
          <h3>24/7 Availability</h3>
          <p>Never miss a message — JibuBot is always online, ready to support your users around the clock.</p>
        </article>

        <article className="benefit-card">
          <FaChartLine className="icon" />
          <h3>Business Growth</h3>
          <p>Increase lead conversions and customer engagement with personalized, instant responses.</p>
        </article>

        <article className="benefit-card">
          <FaMoneyBillWave className="icon" />
          <h3>Cost-Effective</h3>
          <p>Reduce support costs while improving service quality. Scalable, efficient, and budget-friendly.</p>
        </article>
      </div>
    </section>
  );
};

export default WhyJibuBot;
